import { useEffect } from 'react';
import { HighlightedRouteType } from '@lp/features/RoutePlanner/types';
import { RoutePlanType } from '@/types/route';

const toHighlightedRoute = (routePlan: RoutePlanType): HighlightedRouteType => ({
  id: routePlan.id,
  legs: [...routePlan.legs.values()].flat(),
  resources: routePlan.resources,
  locations: routePlan.locations,
});

type UseRouteHighlightParams = {
  isOpen: boolean;
  currentRoutePlan: RoutePlanType | null;
  benchmarkPlan: RoutePlanType | null;
  isPlansLoaded: boolean;
  sortedRoutePlansCount: number;
  onHighlightRoute: (routePlan: HighlightedRouteType | null) => void;
};

export const useRouteHighlight = ({
  isOpen,
  currentRoutePlan,
  benchmarkPlan,
  isPlansLoaded,
  sortedRoutePlansCount,
  onHighlightRoute,
}: UseRouteHighlightParams) => {
  useEffect(() => {
    if (isOpen && currentRoutePlan) {
      onHighlightRoute(toHighlightedRoute(currentRoutePlan));
    }
  }, [isOpen, currentRoutePlan, onHighlightRoute]);

  useEffect(() => {
    if (isOpen && isPlansLoaded && !sortedRoutePlansCount && benchmarkPlan) {
      onHighlightRoute(toHighlightedRoute(benchmarkPlan));
    }
  }, [isOpen, isPlansLoaded, sortedRoutePlansCount, benchmarkPlan, onHighlightRoute]);
};
